import Resolution from "engine/Resolution.js";
import {uuid} from 'uuidv4';
import {setSelectedPianoRollSteps} from 'actions/index.js';

// ASSUMES resolution=1/32n
const RESOLUTION = new Resolution(32, false);

export const strum = (track, steps, stepNumber, strum) => {
    // first delete steps
    let copiedSteps = steps.map(s => s.getCopy(true, false));
    let pattern = track.getEasyPattern();
    pattern.deleteSteps(steps);

    // then add them agagin usingg the chop
    let choppedSteps = [];
    let chopDuration= strum / steps.length;
    let newSteps = [];
    for (let i=0; i < steps.length; i++) {
        let _stepNumber = stepNumber + 2 * i * chopDuration;
        let position = _stepNumber - Math.floor(_stepNumber);
        let _stepData = copiedSteps[i];
        _stepData.id = uuid();
        newSteps.push(
            pattern.addStep(
                _stepData,
                Math.floor(_stepNumber),
                RESOLUTION,
                position));
    }

    track.updateSteps(true);

    track.sequencerEngine.dispatch(
        setSelectedPianoRollSteps(newSteps));
    // return the newly added steps
    return newSteps;
};
